module.exports = __webpack_public_path__ + "static/media/PPT.1356f881.svg";